export const FormType = {
  Single: "Single",
  MultipleRelation: "MultipleRelation",
  MultipleNoneRelation: "MultipleNoneRelation"
};
